import React, { useEffect, useState, useRef, Fragment } from "react";
import NewsletterStyles from "./Newsletter.styled";
import { FormValidation } from "calidation";
import Input from "../Input";
import { animated, useSpring, useChain } from "react-spring";
import useOnClickOutside from "../../lib/useOutsideClick";
import { useAppStore } from "../../stores/AppStore";
import useKeyPress from "../../lib/useKeyPress";

function Newsletter() {
  const [{ scrollTop }, { setScrollTop }] = useAppStore();
  const [
    { isFrench, isNewsletterActive, easing, duration },
    { setIsNewsletterActive, setIsBodyLocked }
  ] = useAppStore();
  const ref = useRef();
  const submitTimer = useRef();

  const reset = () => {
    setIsNewsletterActive(false);
    setIsBodyLocked(false);
    window.requestAnimationFrame(() => {
      window.scroll(0, scrollTop);
      setScrollTop(0);
    });
  };

  useOnClickOutside(ref, () => {
    if (isNewsletterActive) {
      reset();
    }
  });
  const escPress = useKeyPress("Escape");

  const closeProps = useSpring({
    transform: isNewsletterActive ? "rotate(45deg)" : "rotate(0deg)",
    config: { easing, duration }
  });
  const props = useSpring({
    transform: isNewsletterActive
      ? "translate3d(0, 0%, 0)"
      : "translate3d(0, 100%, 0)",
    opacity: isNewsletterActive ? 1 : 0,
    config: { easing, duration }
  });

  const validationConfig = {
    email: {
      isRequired: "Please provide an email address",
      isEmail: "Please enter a valid email address"
    },
    fullName: {
      isMinLength: {
        length: 0,
        message: "Please type your email address",
        validateIf: ({ isDirty }) => isDirty
      }
    }
  };

  const onClick = () => {
    reset();
  };

  const submitForm = async email => {
    const formData = new FormData();
    formData.append(window.csrfTokenName, window.csrfTokenValue);
    formData.append("action", "campaign/t/subscribe");
    formData.append("mailingList", `generalFrench`);
    formData.append("email", email);
    // formData.append("redirect", "success");

    const headers = new Headers({
      "X-Requested-With": "XMLHttpRequest",
      Accept: "*/*"
    });

    const request = {
      method: "POST",
      mode: "same-origin",
      credentials: "include",
      headers,
      body: formData,
      cache: "no-cache"
    };

    const result = await fetch("", request)
      .then(response => response.text())
      .then(response => {
        return true;
        // if (response.ok) return true;
        // return false;
      })
      .catch(error => {
        console.error("Error:", error);
        return false;
      });

    return result;
  };

  const onSubmit = async ({ fields, isValid }) => {
    if (!isValid) {
      return null;
    }
    const response = await submitForm(fields.email);
    clearTimeout(submitTimer.current);
    submitTimer.current = setTimeout(() => {
      setIsNewsletterActive(false);
      setIsBodyLocked(false);
    }, 500);
  };

  useEffect(() => {
    return () => {
      clearTimeout(submitTimer.current);
    };
  }, []);

  useEffect(() => {
    if (isNewsletterActive) {
      setIsBodyLocked(true);
    }
  }, [isNewsletterActive]);

  useEffect(() => {
    if (escPress) {
      setIsNewsletterActive(false);
    }
  }, [escPress]);

  // useEffect(()=> {
  //   closeSet({

  //   })
  // }, [isNewsletterActive]);

  return (
    <NewsletterStyles
      style={{ pointerEvents: isNewsletterActive ? "auto" : "none" }}
    >
      <FormValidation config={validationConfig} onSubmit={onSubmit}>
        {({ fields, errors, submitted, isValid }) => (
          <>
            <animated.section
              style={{ opacity: props.opacity }}
              className="background"
            />
            <animated.section style={props} ref={ref} className="wrapper">
              {submitted && isValid ? (
                <p>Merci De Nous Suivre</p>
              ) : (
                <>
                  <p>
                    Inscrivez-vous pour suivre l’actualité et les prochaines
                    expositions.
                  </p>
                  <section className="input-wrapper">
                    <Input
                      title={"Email Address"}
                      name={"email"}
                      type={"email"}
                      autoComplete={"email"}
                      autoFocus={true}
                      hasError={submitted && errors.email}
                    />
                    {isValid ? (
                      <button>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20.21 20.71"
                        >
                          <path d="M9.85 0L9.14 0.71 18.29 9.85 0 9.85 0 10.85 18.29 10.85 9.14 20 9.85 20.71 20.21 10.35 9.85 0z"></path>
                        </svg>
                      </button>
                    ) : null}
                    <input
                      type="text"
                      name="fullName"
                      className="fullName"
                      style={{ display: "none" }}
                      autoComplete="off"
                    />
                  </section>
                  <section className="submit-wrapper">
                    {fields.email.length > 4 && errors.email && (
                      <span className="error">{errors.email}</span>
                    )}
                  </section>
                </>
              )}
              <button
                className="close"
                onClick={onClick}
                // onMouseEnter={onMouseEnter}
                // onMouseLeave={onMouseLeave}
                // onTouchCancel={onTouchCancel}
                // onTouchEnd={onTouchEnd}
                // onTouchMove={onTouchMove}
              >
                <animated.svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 21 21"
                  style={closeProps}
                >
                  <path d="M21 10L11 10 11 0 10 0 10 10 0 10 0 11 10 11 10 21 11 21 11 11 21 11 21 10z"></path>
                </animated.svg>
              </button>
            </animated.section>
          </>
        )}
      </FormValidation>
    </NewsletterStyles>
  );
}

export default Newsletter;
